module.exports = __webpack_public_path__ + "static/media/stage13.f77bdb48.svg";